
import { useEffect, useRef } from 'react';

function IndustriesServed() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.industry-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.classList.add('opacity-100', 'translate-y-0');
                card.classList.remove('opacity-0', 'translate-y-8');
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const industries = [
    {
      title: 'Home Services & Trades',
      description: 'Automated booking, follow-ups, dispatch coordination, and review generation.',
      image: 'https://public.readdy.ai/ai/img_res/9e3f83fe1f0f21625907b9c6743ca778.jpg',
    },
    {
      title: 'Healthcare & Medical Services',
      description: 'Intake automation, reminders, retention workflows, operational optimization.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20medical%20office%20interior%20with%20digital%20health%20technology%20screens%20and%20minimalist%20design%2C%20soft%20natural%20lighting%2C%20premium%20healthcare%20environment%20photography%2C%20teal%20and%20white%20color%20palette%2C%20professional%20clinical%20setting%20with%20advanced%20technology%20integration&width=600&height=400&seq=ind-health-01&orientation=landscape',
    },
    {
      title: 'Real Estate & Property Development',
      description: 'Lead qualification, nurture flows, pipeline automation, investor reporting.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20real%20estate%20property%20exterior%20at%20golden%20hour%20with%20clean%20architectural%20lines%2C%20premium%20real%20estate%20photography%20with%20warm%20ambient%20lighting%2C%20contemporary%20building%20design%20with%20glass%20and%20concrete%2C%20professional%20commercial%20property%20showcase&width=600&height=400&seq=ind-realestate-01&orientation=landscape',
    },
    {
      title: 'Professional Services',
      description: 'Intelligent intake systems, document workflows, structured client lifecycle management.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20professional%20office%20workspace%20with%20clean%20minimal%20desk%20setup%20and%20digital%20screens%20showing%20business%20analytics%2C%20premium%20corporate%20photography%20with%20soft%20natural%20lighting%2C%20contemporary%20workspace%20design%20with%20teal%20accent%20details%2C%20high%20end%20commercial%20aesthetic&width=600&height=400&seq=ind-prof-01&orientation=landscape',
    },
  ];

  return (
    <section id="industries" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p className="text-sm font-medium tracking-[0.2em] uppercase text-[#2DD4BF] mb-4">
            Industries
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-[56px] font-semibold text-gray-900 tracking-tight">
            Where Wazier AI Operates
          </h2>
        </div>

        <div ref={sectionRef} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="industry-card opacity-0 translate-y-8 transition-all duration-700 ease-out rounded-2xl overflow-hidden group cursor-pointer relative"
            >
              <div className="w-full h-72 overflow-hidden">
                <img
                  src={industry.image}
                  alt={industry.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <h3 className="text-xl font-semibold text-white mb-2">
                  {industry.title}
                </h3>
                <p className="text-sm text-white/70 leading-relaxed font-light">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default IndustriesServed;
